// src/menu-items/statistics.ts
import { User, UserPlus } from 'iconoir-react';


const accounts = {
  id: 'accounts-group',
  title: 'Accounts',
  type: 'group',
  children: [
    {
      id: 'accounts-search',
      title: 'Accounts',
      type: 'item',
      url: '/accounts/search',
      icon: User,
      breadcrumbs: true
    },
    {
      id: 'accounts-create',
      title: 'Create Account',
      type: 'item',
      url: '/accounts/create',
      icon: UserPlus,
      breadcrumbs: true
    }
  ]
};

export default accounts;
